<script setup>
import LoadingAnimation from '#/general/LoadingAnimation'
const props = defineProps({ showing: Boolean, type: { type: String, default: 'IOS' } })
</script>

<template lang="pug">
.innerLoadingContainer(v-if="showing")
  loading-animation(:type="type")
  slot
</template>

<style scoped lang="sass">
.innerLoadingContainer
  position: absolute
  z-index: 100
  top: 0
  left: 0
  width: 100%
  height: 100%
  background-color: #000
  opacity: 0.5
  display: flex
  justify-content: center
  align-items: center
  transition: background-color 0.28s
</style>
